<template>
	<div>
		<loader v-if="pageLoader" />
		<div class="row">
	        <div class="col-12">
	            <label class="mb-2 semibold themecolor">2-Factor Authentication Code</label>
	            <input type="text" class="form-control" placeholder="" v-model="otpForDeleteBank"  name="otpForDeleteBank" required=""  v-validate="{ required: true, max :6 }" />
	            <span v-if="deletePaymentReqSubmitted && errors.has('otpForDeleteBank')" class="text-danger">{{ errors.first("otpForDeleteBank") }}</span>
	        </div>
	    </div>
	    <div class="d-flex align-items-center justify-content-center">
	        <a href="javascript:void(0)" class="cap_btn large_btn secondaryBG w-100 mt-3" data-toggle="modal" data-target="#withdrawalmessage" @click="deletePaymentMethod()">Confirm</a>
	    </div>
	</div>
</template>
<script>
  import { depositWithdrawalMixins } from "@/plugins/depositWithdrawal";
  import { Const } from "@/plugins/vue-provider-cache/const.mod";
  import tradingMixins from "@/plugins/trading";
  export default {
    name: "deposit-section",
    mixins: [depositWithdrawalMixins, tradingMixins],
    data() {
      return {
        pageLoader: false,

        otpForDeleteBank : '',
        deletePaymentReqSubmitted : false,
      };
    },
    computed: {},
    props:['bankData', 'pageNameData'],
    methods: {
        deletePaymentMethod(){
            const _that  = this
            _that.deletePaymentReqSubmitted = true;
            _that.$validator.validate().then((valid) => {
                if (valid) {
                    let json = {
                        globalParams: {
                            "bank_id" : _that.bankData.id,
                            "benificiary_id" : _that.bankData.benificiary_id,
                            "google_token" : _that.otpForDeleteBank
                        },
                        localParams: { parameter: _that , pagename :  _that.pageNameData},
                    }
                    _that._runDeletePaymentMethod(json);
                }
            })
        },
        reset(){
        	this.otpForDeleteBank = ''
        	this.deletePaymentReqSubmitted = false
        }
    },
    created() {}
  };
</script>


// WEBPACK FOOTER //
// src/components/website/bank/delete-bank.vue